"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableSelect = void 0;
const react_1 = require("react");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const navigation_context_1 = require("../../navigation/navigation-context");
function useTableSelect({ source, listRef, onActiveChange, }) {
    const { testPrompts } = react_1.useContext(navigation_context_1.NavigationContext);
    /**
     * Selected item ids.
     */
    const [selected, setSelected] = react_1.useState([]);
    const [activeRow, setActiveRowInternal] = react_1.useState(null);
    /**
     * Toggles between selecting all rows and no rows.
     *
     * Only visible (loaded) rows can be selected.
     * If at least one row is selected, next toggle will deselect all.
     */
    const toggleAllRowSelection = event_callback_hook_1.useEventCallback(() => setSelected((selected) => selected.length > 0 ? [] : source.items.map((row) => row.id)));
    /**
     * Toggles between selecting one row.
     */
    const toggleRowSelection = event_callback_hook_1.useEventCallback((id) => {
        setSelected((selected) => selected.includes(id)
            ? selected.filter((r) => r !== id)
            : [...selected, id]);
    });
    /**
     * Resets selection.
     */
    const resetSelection = event_callback_hook_1.useEventCallback(() => {
        setSelected([]);
    });
    const setActiveRow = event_callback_hook_1.useEventCallback((id) => {
        if (id !== activeRow) {
            testPrompts(() => {
                setActiveRowInternal(id);
                onActiveChange(id);
            });
        }
    });
    const setNextRowActive = event_callback_hook_1.useEventCallback(() => {
        var _a;
        const count = source.items.length;
        if (count > 0) {
            const activeIndex = source.items.findIndex((item) => item.id === activeRow);
            const nextIndex = Math.min(activeIndex + 1, count - 1);
            setActiveRow(source.items[nextIndex].id);
            (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(nextIndex);
        }
    });
    const setPrevRowActive = event_callback_hook_1.useEventCallback(() => {
        var _a;
        const count = source.items.length;
        if (count > 0) {
            const activeIndex = source.items.findIndex((item) => item.id === activeRow);
            const prevIndex = Math.max(activeIndex - 1, 0);
            setActiveRow(source.items[prevIndex].id);
            (_a = listRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem(prevIndex);
        }
    });
    return {
        selected,
        activeRow,
        toggleAllRowSelection,
        toggleRowSelection,
        resetSelection,
        setActiveRow,
        setNextRowActive,
        setPrevRowActive,
    };
}
exports.useTableSelect = useTableSelect;
//# sourceMappingURL=table-select-hook.js.map